import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './SuccessPartners.module.css';
import API_BASE_URL from '../../config/api';

const SuccessPartners = () => {
  const { t, i18n } = useTranslation();
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    const controller = new AbortController();

    const fetchPartners = async () => {
      try {
        const lang = i18n.language === 'ar' ? 'ar' : 'en';
        const res = await fetch(
          `${API_BASE_URL}/partners?lang=${lang}`,
          { signal: controller.signal },
        );
        const data = await res.json();
        const items = Array.isArray(data) ? data : data.data || [];

        setPartners(
          items.map((item) => ({
            id: item.slug,
            name: item.name,
            amount: item.amount,
            image: item.image_url || null,
          })),
        );
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Failed to load partners', error);
        }
      }
    };

    fetchPartners();

    return () => controller.abort();
  }, [i18n.language]);

  return (
    <div className={styles.partnersPage}>
      {/* Hero Section */}
      <section className={styles.heroSection}>
        <div className={styles.heroOverlay}></div>
        <div className={styles.heroContent}>
          <h1 className={styles.heroTitle}>{t('partners.title')}</h1>
          <p className={styles.heroSubtitle}>{t('partners.subtitle')}</p>
          <div className={styles.heroUnderline}></div>
        </div>
      </section>

      {/* Partners Section */}
      <section className={styles.partnersSection}>
        <div className={styles.container}>
          <div className={styles.partnersGrid}>
            {partners.map((partner) => (
              <div key={partner.id} className={styles.partnerCard}>
                <div className={styles.logoContainer}>
                  {partner.image ? (
                    <img 
                      src={partner.image} 
                      alt={partner.name || 'Partner Logo'}
                      className={styles.partnerLogo}
                    />
                  ) : (
                    <div className={styles.logoPlaceholder}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                        <circle cx="8.5" cy="8.5" r="1.5" />
                        <polyline points="21 15 16 10 5 21" />
                      </svg>
                    </div>
                  )}
                </div>
                <div className={styles.cardContent}>
                  <div className={styles.amountContainer}>
                    <span className={styles.amountValue}>{partner.amount}</span>
                    <span className={styles.amountLabel}>
                      {t('partners.million')} {t('partners.currency')}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default SuccessPartners;
